import { EErrorNotificationActionType } from './types';
import { INotificationError } from '../../types/notifications';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const removeErrorNotification = actionGenerator<EErrorNotificationActionType.Removed, INotificationError['id']>(
  EErrorNotificationActionType.Removed,
);
